<template>
<div class="chapter">
<div class="inner_page">
<div id="Contents">
<p class="toc-title">CONTENTS</p>
<p class="toc"><a href="#/xhtml/06_Chapter01">Design</a></p>
<p class="toc"><span href="#/xhtml/07_Chapter02" title="Link target outside of Sample">Operations</span></p>
<p class="toc"><span href="#/xhtml/08_Chapter03" title="Link target outside of Sample">Model Products</span></p>
<p class="toc"><span href="#/xhtml/09_Chapter04" title="Link target outside of Sample">Modelmakers’ Showcase</span></p>
<p class="toc"><span href="#/xhtml/10_Chapter05" title="Link target outside of Sample">Colour Schemes</span></p>
<p class="toc"><span href="#/xhtml/11_Chapter06" title="Link target outside of Sample">Appearance</span></p>
<p class="toc"><span href="#/xhtml/12_Chapter07" title="Link target outside of Sample">Plans</span></p>
<p class="toc1"><span href="#/xhtml/13_References" title="Link target outside of Sample">Selected References</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Contents.vue?a4d38916